import { render, staticRenderFns } from "./MetricEditIndicator.vue?vue&type=template&id=24580d64"
import script from "./MetricEditIndicator.vue?vue&type=script&lang=js"
export * from "./MetricEditIndicator.vue?vue&type=script&lang=js"
import style0 from "./MetricEditIndicator.vue?vue&type=style&index=0&id=24580d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports